import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import { useImportCSVData } from 'app/store/importCSV'
import { sendCSVFileDataToValidateThunk } from 'app/store/importCSV/importCSVExtraReducers'
import MessageAlert from 'app/components/MessageAlert'
import { checkSubscribersImport } from 'app/store/importCSV/helpers'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import { SECONDARY } from 'app/constants/button'
import { useState } from 'react'

const ValidateButton = () => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const {
    data: { infoMappedHeaders, rows },
  } = useImportCSVData()

  const { formatMessage } = useIntl()

  const disabledBtn = useMemo(() => {
    if (!rows.length) {
      return true
    }
    const numberOfInvalidHeaders = infoMappedHeaders.filter(
      ({ isInvalid, required }) => isInvalid && required,
    ).length
    return numberOfInvalidHeaders > 0
  }, [infoMappedHeaders, rows])

  const showSnackbar = (msg) => {
    const secondsInmillisec = 10000
    dispatch(
      MessageAlert.showError({ message: msg, duration: secondsInmillisec }),
    )
  }

  const handleValidate = async () => {
    if (!disabledBtn) {
      setIsLoading(true)
      const handleShowSnackbar = () => {
        showSnackbar(formatMessage({ id: 'wrong.msg' }))
        setIsLoading(false)
      }
      const isInProcess = await checkSubscribersImport({ handleShowSnackbar })
      if (isInProcess) {
        showSnackbar(
          formatMessage({
            id: 'subscribers.import.importInProcess.errorMessage',
          }),
        )
        return
      }
      dispatch(sendCSVFileDataToValidateThunk())
    }
  }

  return (
    <ContainedButton
      size="small"
      color={SECONDARY}
      disabled={disabledBtn || isLoading}
      onClick={handleValidate}
      isLoading={isLoading}
      className={'h-36 w-full md:w-fit text-14'}
    >
      <FormattedMessage
        id={'subscribers.import.previewTable.ValidateBtn.label'}
      />
    </ContainedButton>
  )
}

export default ValidateButton
